export default "__VITE_ASSET__BaC0W6JH__"